import script from "./BestSellerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BestSellerCard.vue?vue&type=script&setup=true&lang=js"

import "./BestSellerCard.vue?vue&type=style&index=0&id=5c59bade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c59bade"]])

export default __exports__